import { CreateNewsData, News, NewsService } from "@/client";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

function useCreateNews(
  mutationOptions?: UseMutationOptions<News, HttpError, CreateNewsData>,
) {
  return useMutation({
    mutationFn: NewsService.createNews,
    ...mutationOptions,
  });
}

export { useCreateNews };
